// const log = global.log.getLogger("f_mtac.ui.ConfirmationArea");
const LoadingArea = function () {
    var {Modal} = window.f_mtac_theme;
    var loading_area_modal;
    var $loading_area = document.getElementById("loading_area");

    this.close = () => loading_area_modal.hide();

    this.interact = function ({tip = ""}) {
        loading_area_modal = new Modal($loading_area, {
            backdrop: "static", // avoid closing window when clicking outside
            keyboard: false
        });
        $("#loading_area .tip").html(tip); // AGPOC-4659: use .html() for special characters
        return new Promise((resolve) => {
            const interaction_end = () => {
                resolve();
                $loading_area.removeEventListener("hidden.bs.modal", interaction_end);
            };
            $loading_area.addEventListener("hidden.bs.modal", interaction_end);
            loading_area_modal.show();
        });
    };

};
export default new LoadingArea();
